import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select, Button, OutlinedInput } from '@material-ui/core/';
import useStyles from './ControlledSelect.style.js';
import Truncate from '../Truncate/Truncate';

/**
 * A wrapper around Material-UI's Select component with a Button to control the opening/closing of the menu.
 * In addition to the props for this component, you can pass in the full list of props for Material-UI's select component (https://material-ui.com/api/select/)
 */
const ControlledSelect = (props) => {
  const {
    controlLabel,
    children,
    inputProps,
    disabled,
    classes: propClasses,
    isSelected,
    ...rest
  } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleSelectClose = () => {
    setOpen(false);
  };

  const handleSelectOpen = () => {
    setOpen(true);
  };

  const MenuProps = {
    classes: {
      paper: classes.paper,
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    getContentAnchorEl: null,
  };

  const IconComponent = () => {
    return disabled ? (
      ''
    ) : (
      <Button color='primary' className={classes.button} onClick={handleSelectOpen}>
        <Truncate text={controlLabel}></Truncate>
      </Button>
    );
  };

  return (
    <>
      <Select
        {...rest}
        disabled={disabled}
        open={open}
        onClose={handleSelectClose}
        onOpen={handleSelectOpen}
        classes={{
          ...propClasses,
          select: classes.select,
          outlined: classes.outlined,
        }}
        input={
          <OutlinedInput
            {...inputProps}
            classes={{
              notchedOutline: isSelected ? classes.selectedNotchedOutline : classes.notchedOutline,
            }}
          />
        }
        MenuProps={MenuProps}
        data-locator='control-select'
        IconComponent={IconComponent}>
        {children}
      </Select>
    </>
  );
};

ControlledSelect.propTypes = {
  /**
   * The label for the button that will open/close the select
   */
  controlLabel: PropTypes.string,
  /**
   * The content of the select
   */
  children: PropTypes.node.isRequired,
  /**
   * Should the select be able to open?
   */
  disabled: PropTypes.bool,
  /**
   * Should the Select look like it is a selected component?
   */
  isSelected: PropTypes.bool,
  /**
   * Object of classes to apply to the select, such as any custom classes for the disabled state (classes.disabled)
   */
  classes: PropTypes.object,
  /**
   * The value in the select
   */
  value: PropTypes.any,
  /**
   * Callback fired when a new value is selected
   */
  onChange: PropTypes.func,
  /**
   * Should the empty value option be displayed?
   */
  displayEmpty: PropTypes.bool,
};

export default ControlledSelect;
